"use client";
import React, { useState } from "react";
import { useTranslations } from "use-intl";
import { CategoryModel } from "@/types/category";
import { SlidersHorizontal } from "lucide-react";
import { Button } from "../ui/button";
import { Separator } from "../ui/separator";
import PriceRange from "../product/price-range";
import { Sheet, SheetContent, SheetTrigger } from "../ui/sheet";
import CategoriesSidebar from "./categories-sidebar";

const CategoriesFiltersDrawer = ({
  categories,
}: {
  categories: CategoryModel[];
}) => {
  const [open, setOpen] = useState(false);
  const t = useTranslations();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger>
        <Button
          variant="outline"
          className="flex items-center gap-2"
          onClick={() => setOpen(true)}
        >
          <SlidersHorizontal className="size-5" />
          {t("categories")}
        </Button>
      </SheetTrigger>
      <SheetContent className="p-4 bg-white space-y-4 overflow-y-auto ">
        <div>
          <h2 className="font-bold mb-4 text-xl">{t("categories")}</h2>
          <CategoriesSidebar categories={categories} setOpen={setOpen} />
        </div>

        <Separator />
        <div>
          <h2 className="font-bold mb-4 text-md">{t("priceRange")}</h2>
          <PriceRange />
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default CategoriesFiltersDrawer;
